import React, { ReactElement, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { loadImageBuffer } from '../../../../common/utils/utils';
import parseAPNG from 'apng-js';
import { Debug } from '../../../../common/utils/debugLogs';

interface AnimationPlayerProps {
  message: string;
  messageId: string | undefined;
  url: string | undefined;
  onFinish: () => void;
}

export const AnimationPlayer = (props: AnimationPlayerProps): ReactElement => {
  // handle when video finish load metadata
  const onVideoMetaDataLoaded = () => {
    const video = document.querySelector(
      '.life-gift__media_video',
    ) as HTMLVideoElement;

    Debug.log(`Mp4 playtime: ${video.duration}`);
    let playTime = 100;
    if (video.duration) {
      playTime = video.duration * 1000;
    }
    // set finish callback
    setTimeout(() => {
      props.onFinish();
    }, playTime);
  };

  useEffect(() => {
    // get image buffer from image url to get APNG play time
    if (props.url !== undefined && props.url.indexOf('.mp4') === -1) {
      loadImageBuffer(props.url).then((buffer) => {
        const apng = parseAPNG(buffer);
        if (apng instanceof Error) {
          // unable to decode apng, fallback to 1s timeout
          setTimeout(() => {
            props.onFinish();
          }, 1000);
          return;
        }

        // set finish when animation finish play
        Debug.log(`Apng playtime: ${apng.playTime}`);
        setTimeout(() => {
          props.onFinish();
          // keep エブリルーレット image tab display longer a little bit
        }, apng.playTime + 500);
      });
    }
  }, []);

  if (props.url === undefined) {
    return <></>;
  }

  return (
    <div className="live-gift__animation">
      <span className="life-gift__text">{props.message}</span>
      {/* Gift Media */}
      {props.url.indexOf('.mp4') > -1 ? (
        <video
          className="life-gift__media_video"
          src={props.url}
          onLoadedMetadata={onVideoMetaDataLoaded}
          autoPlay
        ></video>
      ) : (
        <Image
          className="life-gift__media_apng"
          src={`${props.url}?${props.messageId}`}
        />
      )}
    </div>
  );
};
